//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

export default {
  name: 'SimpleParagraph',
  components: {
    GlobalRichText
  },
  props: {
    paragraph: {
      type: Array,
      required: true
    },
    hasReadMore: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hideText: this.hasReadMore
    };
  }

};